<script setup lang="ts">
  import { CustomCheckbox } from '@/shared/ui';

  const props = defineProps<{
    title: string;
    collaborators: Array<{ id: number; name: string; position: string }>;
  }>();
</script>

<template>
  <div data-testid="collaborator-selection-section">
    <div class="font-semibold flex items-start text-sm/5 mb-6">
      {{ title }}
    </div>
    <div class="border border-border-color rounded-2xl bg-gray-02/20 text-sm/5 p-6">
      <table class="min-w-1/2 text-left">
        <thead>
          <tr>
            <th class="font-semibold pb-3 pr-8">
              Colaborador
            </th>
            <th class="font-semibold pb-3">
              Cargo
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="col in collaborators"
            :key="col.id"
          >
            <td class="flex gap-3 py-1.5 pr-8">
              <CustomCheckbox
                :id="`collab-checkbox-${col.id}`"
                :checked="true"
                :disabled="true"
              />
              <span>{{ col.name }}</span>
            </td>
            <td class="py-1.5">
              {{ col.position }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-3 text-sm text-left">
      Total de colaboradores selecionados: {{ collaborators.length }}
    </div>
  </div>
</template>
